export default "__VITE_ASSET__Cxiklfro__"